module.exports = __webpack_public_path__ + "assets/img/more.8e54e59d.svg";